export const ADD_CONTENT_SUCCESS_MESSAGE = "Added to";
export const DELETE_CONTENT_SUCCESS_MESSAGE = "Removed from";
